import { render, staticRenderFns } from "./MenusEdit.vue?vue&type=template&id=42ac550d&scoped=true&"
import script from "./MenusEdit.vue?vue&type=script&lang=js&"
export * from "./MenusEdit.vue?vue&type=script&lang=js&"
import style0 from "./MenusEdit.vue?vue&type=style&index=0&id=42ac550d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ac550d",
  null
  
)

export default component.exports